import e from"./images/snowflake-1.png.js";import m from"./images/snowflake-2.png.js";import o from"./images/snowflake-3.png.js";var r=[e,m,o].map(function(e){var m=document.createElement("img");return m.src=e,m});export{r as customSnowflake};
//# sourceMappingURL=contants.js.map
